import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";

import Header from "../../components/Header";
import Buttons from "../../components/Buttons";
import Footer from "../../components/Footer";

export default function CompanyPage() {
  const [companyData, setCompanyData] = useState();
  const location = useLocation();

  const path = location.pathname.split("/").pop();

  const fetchCompany = async () => {
    axios({
      url: `${process.env.REACT_APP_API_URL}online-menu/${path}/company`,
      params: {
        include: "logo,payment_types",
      },
      method: "GET",
    })
      .then((response) => {
        if (response?.data && response?.data?.taplink) {
          setCompanyData(response?.data);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    fetchCompany();
  }, [path]);

  return (
    <div className="taplink-container">
      <Header companyData={companyData} />
      <Buttons companyData={companyData} />
      <Footer />
    </div>
  );
}
